import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchReligions, deleteReligion } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'religionId', label: 'ID', minWidth: 50 },
  { id: 'religionName', label: 'Religion Name', minWidth: 170 },
  { id: 'description', label: 'Description', minWidth: 300 },
];

const ReligionList = ({ onEdit, searchQuery = '' }) => {
  const [religions, setReligions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadReligions = async () => {
      setLoading(true);
      try {
        const response = await fetchReligions();
        if (cancelled) return;
        setReligions(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching religions:', err);
        if (!cancelled) {
          setError('Failed to load religions. Please try again later.');
          setReligions([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadReligions();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (religion) => {
    try {
      await deleteReligion(religion.religionId, {
        previousData: religion,
        identifier: religion.religionName
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting religion:', err);
      alert('Failed to delete religion. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Religions
      </Typography>
      
      <MasterDataTable
        persistKey="religion"
        data={religions}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No religions found. Add your first religion!"
      />
      
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default ReligionList; 